import { render, staticRenderFns } from "./UserNav.vue?vue&type=template&id=53ddd6c1&scoped=true"
import script from "./UserNav.vue?vue&type=script&lang=js"
export * from "./UserNav.vue?vue&type=script&lang=js"
import style0 from "./UserNav.vue?vue&type=style&index=0&id=53ddd6c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ddd6c1",
  null
  
)

export default component.exports